<template>
  <div>
    <div class="titleAfter">心理分析</div>
    <div class="table">
      <table>
        <thead>
          <th v-for="(item, index) in tableHead" :key="index">
            {{ item }}
          </th>
        </thead>
        <tbody>
          <tr v-for="(row, index) in tableData" :key="index">
            <td>{{ row.project }}</td>
            <td>{{ row.range }}</td>
            <td>{{ row.judge }}</td>
            <td>{{ row.minimum }}</td>
            <td>{{ row.maxmum }}</td>
            <td>{{ row.average }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const tableHead = ref(["项目", "范围", "判定", "最小值", "平均值", "最大值"]);
const tableData = ref([
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
  {
    project: "冲动指数",
    range: "20-50",
    judge: "正常",
    minimum: "33.62",
    maxmum: "34.52",
    average: "44.15",
  },
]);
</script>

<style lang="scss" scoped>
.titleAfter {
  position: relative;
  font-weight: bold;
  color: #4aefff;
}
.titleAfter::after {
  content: "";
  position: absolute;
  left: -8px;
  top: 2px;
  width: 3px;
  height: 14px;
  background: #4aefff;
  border-radius: 38px 38px 38px 38px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th,
td {
  text-align: left;
  padding: 8px;
}

th {
  background-color: #124E91;
  font-weight: bold;
}

tr:nth-child(even) {
  background-color: #124E91;
}

tr:hover {
  background-color: #072241;
}


</style>
